import React, { useState } from "react";
import { Icon } from "@mui/material";
import ChangeSelectionModal from "./ChangeSelectionModal";

const EditBuildingButton = ({
  children,
  AccSession,
  AppHour,
  AppDay,
  GetAppDayById,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = (e) => {
    if (e) e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      {children ? (
        <div onClick={handleOpen} style={{ cursor: "pointer", display: "contents" }}>
          {children}
        </div>
      ) : (
        <button
          className="btn btn-sm btn-outline-light"
          style={{
            padding: "0px 8px",
            fontSize: "0.7em",
            marginLeft: "10px",
            height: "22px",
            display: "inline-flex",
            alignItems: "center",
            borderColor: "rgba(255,255,255,0.5)",
          }}
          onClick={handleOpen}
          title="Edit Building"
        >
          <Icon style={{ fontSize: "14px", color: "#fff" }}>business</Icon>
        </button>
      )}

      <ChangeSelectionModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        AccSession={AccSession}
        AppHour={AppHour}
        AppDay={AppDay}
        GetAppDayById={GetAppDayById}
        type="building"
      />
    </>
  );
};

export default EditBuildingButton;
